import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  errorMessage: null,
  totalItems: 0,
};

export type AdministrationState = Readonly<typeof initialState>;

export const AdministrationSlice = createSlice({
  name: 'administration',
  initialState: initialState as AdministrationState,
  reducers: {},
});

export default AdministrationSlice.reducer;
